import { Address } from '../address.model';
import {
  OrderMethod,
  ExtraParams,
  Sort,
  FACET_SET_UMAMI_V2,
  SORT_SET_ID_DEFAULT,
} from './search-query-model-types';

type FacetHashMap = Record<string, boolean>;

/**
 * SearchQuery model
 *
 * {
 *   address: Address, (refer to Address model)
 *   orderMethod: 'delivery' (delivery | pickup, required, default: delivery),
 *   queryText: 'pizza' (optional),
 *   sort: { field, link_fragment, url } (holds the sort parameter information),
 *   extraParameters: { facet: 'dish:Pizza', pageNum: 2, facetCount: 'browse_hierarchy:50' }
 *   (holds the dynamic search parameters, can be empty)
 * }
 */

export class SearchQuery {
  /* tslint:disable */
  public address: Address;
  public contentTag: string;
  public countOmittingTimes: boolean;
  public extraParameters: ExtraParams;
  public facetSet: string;
  public fieldSet: string;
  public isFutureOrder: boolean;
  public location: string;
  public orderMethod: OrderMethod;
  public locationMode: OrderMethod;
  public pageSize: number;
  public queryText: string;
  public rating_bayesian_10_point: number;
  public searchId: string;
  public searchMetrics: boolean;
  public sort: Sort;
  public sortSetId: string;
  public sponsoredSize: number;
  public userHasSearched: boolean;
  public variationId: string;
  public whenFor: string;
  public whenFrom: string;
  public whenTo: string;
  public presetFacetHashMapMemo: FacetHashMap;
  public brand_id_uncollapsed?: string;
  /* tslint:enable */

  constructor(data?: any) {
    // Extra parameters should hold the facets and sorting
    this.reset();
    Object.assign(this, data);

    // normalize
    this.setOrderMethod(data && data.orderMethod);
  }

  /**
   * Resets the searchQuery model so that facets, queryText, etc. can be set by the routeParams.
   */
  public reset(): void {
    this.contentTag = null;
    this.extraParameters = {};
    this.facetSet = FACET_SET_UMAMI_V2;
    this.fieldSet = null;
    this.isFutureOrder = null;
    this.orderMethod = OrderMethod.DELIVERY;
    this.pageSize = null;
    this.queryText = null;
    this.rating_bayesian_10_point = 0;
    this.searchId = null;
    this.sort = null;
    this.sortSetId = SORT_SET_ID_DEFAULT;
    this.sponsoredSize = null;
    this.variationId = null;
    this.whenFor = null;
    this.whenFrom = null;
    this.whenTo = null;
  }

  private setOrderMethod(orderMethod: OrderMethod): void {
    // it is possilble to get orderMethods such as INCOMPLETE_DELIVERY and INCOMPLETE_PICKUP, could come from cart
    if (orderMethod === OrderMethod.DELIVERY_OR_PICKUP) {
      this.orderMethod = OrderMethod.DELIVERY_OR_PICKUP;
    } else if (new RegExp(OrderMethod.PICKUP, 'i').test(orderMethod)) {
      this.orderMethod = OrderMethod.PICKUP;
    } else {
      this.orderMethod = OrderMethod.DELIVERY;
    }
  }
}
